export enum PeopleActionEnum {
  Demote = 'Demote',
  Promote = 'Promote',
  Approve = 'Approve',
  Accept = 'Accept',
  Deny = 'Deny',
}